import { NARRATIVE_VALUATOR_COMPANY_FRAGMENT } from '@/pages/Narrative/hooks/narrativeValuatorCompanyFragment';
import { gql } from '@/utilities/gql';
import { makeGqlSuspenseQuery } from '@/utilities/gqlQuery';
import { NARRATIVE_MINI_VALUATOR_EDIT_NARRATIVE_FRAGMENT } from '../components/NarrativeMiniValuatorFormEdit';
import { DRAFT_UPDATE_FRAGMENT } from '@/pages/Narrative/hooks/draftUpdateFragment';
import { LATEST_PUBLISHED_UPDATE_FRAGMENT } from '@/pages/Narrative/hooks/latestPublishedUpdateFragment';

const QUERY = gql(
  `
  query NarrativeMiniValuatorCompany($canonicalUrl: String!) {
    Company(canonicalURL: $canonicalUrl) {
      id
      name
      tickerSymbol
      canonicalURL
      info {
        url
      }
      ...NarrativeValuatorCompanyFields

      myNarrative {
        ...NarrativeMiniValuatorEditNarrativeFields
        draftUpdate {
          ...DraftUpdateFields
        }
        latestPublishedUpdate {
          ...LatestPublishedUpdateFields
        }
      }
    }
  }
`,
  [
    NARRATIVE_VALUATOR_COMPANY_FRAGMENT,
    NARRATIVE_MINI_VALUATOR_EDIT_NARRATIVE_FRAGMENT,
    DRAFT_UPDATE_FRAGMENT,
    LATEST_PUBLISHED_UPDATE_FRAGMENT,
  ]
);

export const useNarrativeMiniValuatorCompany = makeGqlSuspenseQuery(QUERY, {
  tags: ['narrative', 'narrative-mini-valuator'],
});
